import { getProductInventoryApi } from '../pages/product-inventory/productrinventory.common.utils';
import {
  ALL_INVENTORY_PRODUCTS,
  LOW_INVENTORY_PRODUCTS,
  OUT_OF_STOCK_INVENTORY,
  INVENTORY_IS_FETCHING,
  INVENTORY_IS_FETCHED,
  INVENTORY_ERROR_FETCHING,
  CHANGE_INVENTORY_TABS,
  SHOW_PRODUCT_INVENTORY_VIEW,
  HIDE_PRODUCT_INVENTORY_VIEW
} from './types';

const fetchingData = (type) => ({
  type,
  actionType: INVENTORY_IS_FETCHING
});

export const productInventoryFetchComplete = (type, payload) => ({
  type,
  actionType: INVENTORY_IS_FETCHED,
  payload
});

const fetchingError = (type, payload) => ({
  type,
  actionType: INVENTORY_ERROR_FETCHING,
  payload
});

export const getAllInventoryProducts = () => {
  const type = ALL_INVENTORY_PRODUCTS;
  return async (dispatch, getState) => {
    dispatch(fetchingData(type));
    const { token } = getState().session;
    const params = {
      action: 'listing',
      pageNo: 1,
      token,
      inventory:true,
      'all-products':true
    }
    try {
      const data = await getProductInventoryApi(params);
      dispatch(productInventoryFetchComplete(type, data));
    } catch (err) {
      dispatch(fetchingError(type, 'Server Error'));
    }
  }
}

export const getLowInventoryProducts = () => {
  const type = LOW_INVENTORY_PRODUCTS;
  return async (dispatch, getState) => {
    dispatch(fetchingData(type));
    const { token } = getState().session;
    const params = {
      action: 'listing',
      pageNo: 1,
      token,
      inventory:true,
      'low-inventory':true
    }
    try {
      const data = await getProductInventoryApi(params);
      dispatch(productInventoryFetchComplete(type, data));
    } catch (err) {
      dispatch(fetchingError(type, 'Server Error'));
    }
  }
}

export const getOutOfStockInventories = () => {
  const type = OUT_OF_STOCK_INVENTORY;
  return async (dispatch, getState) => {
    dispatch(fetchingData(type));
    const { token } = getState().session;
    const params = {
      action: 'listing',
      pageNo: 1,
      token,
      inventory:true,
      'out-of-stock':true
     
    }
    try {
      const data = await getProductInventoryApi(params);
      dispatch(productInventoryFetchComplete(type, data));
    } catch (err) {
      dispatch(fetchingError(type, 'Server Error'));
    }
  }
}

export const updateInventoryTab = (payload) => ({
  type: CHANGE_INVENTORY_TABS,
  payload
});

export const toggleInventoryBatch = (payload) => ({
  type: payload ? SHOW_PRODUCT_INVENTORY_VIEW : HIDE_PRODUCT_INVENTORY_VIEW,
  payload
});